import React from 'react';
import { Spinner } from 'reactstrap';

/**
 * Component for loading wheel
 *
 * @module Loading
 */
export const Loading = () => (
  <div className="componentLoading">
    <div className="loadingIcon">
      <Spinner color="primary" />
    </div>
  </div>
);
